import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import i18n from "@/language/i18n";
import isFunction from 'lodash/isFunction';

export default {
  props: {
    sortItems: { type: Boolean, default: true },
    oftenUsedOptions: {
      type: Object, default: undefined, validator: (value) => {
        /**
        * { path: 'path.to.prop', valuesOrder: ["4", "6", ["1"]]}
        */
        if (typeof value.path !== 'string') { return false }
        if (!Array.isArray(value.valuesOrder)) { return false }
        return true;
      }
    },
    dividIntoSortedSections: { type: Boolean, default: true },
  },
  computed: {
    sortedItems() {
      return sortItemsModule.getSortedItems(this.$props, this.items);
    }
  },
}

export const sortItemsModule = (function () {

  var _props, _items;

  var getSortedItems = function (props, items) {
    if (props.sortItems === false || !items || items.length < 2) { return items }

    _props = cloneDeep(props);
    _items = cloneDeep(items);

    return _sortItems();
  }

  var _sortItems = function () {
    let { sortedOftenUsedItems, sortedOtherItems } = _splitIntoSortedChunks(_items);
    return _reuniteChunks(sortedOftenUsedItems, sortedOtherItems);
  }

  var _splitIntoSortedChunks = function (items) {
    return {
      sortedOftenUsedItems: items.filter(_isOftenUsed).sort(_byFixedItemIndex),
      sortedOtherItems: items.filter(_isOther).sort(_byValue),
    }
  }

  var _reuniteChunks = function (sortedOftenUsedItems, sortedOtherItems) {
    if (_props.dividIntoSortedSections && sortedOftenUsedItems.length > 0) {
      return _concatWithSections(sortedOftenUsedItems, sortedOtherItems);
    }
    return sortedOftenUsedItems.concat(sortedOtherItems);
  }

  var _isOftenUsed = function (item) {
    if (_props.oftenUsedOptions == undefined) { return false }
    return _props.oftenUsedOptions.valuesOrder.indexOf(get(item, _props.oftenUsedOptions.path)) >= 0;
  }

  var _isOther = function (item) {
    return !_isOftenUsed(item);
  }

  var _byValue = function (item1, item2) {
    const value1 = isFunction(_props.itemText) ? _props.itemText(item1) : get(item1, _props.itemText);
    const value2 = isFunction(_props.itemText) ? _props.itemText(item2) : get(item2, _props.itemText);
    return _interpret(value1, value2);
  }

  var _byFixedItemIndex = function (item1, item2) {
    
    let indexOfItem1 = _props.oftenUsedOptions.valuesOrder.indexOf(get(item1, _props.oftenUsedOptions.path));
    let indexOfItem2 = _props.oftenUsedOptions.valuesOrder.indexOf(get(item2, _props.oftenUsedOptions.path));
    
    return _interpret(indexOfItem1, indexOfItem2);
  }

  var _interpret = function (item1, item2) {
    if (item1 === item2) { return 0 }
    if (item1 < item2) { return -1 }
    return 1;
  }

  /***********************
   * ### CHUNK HELPERS ###
   **********************/
  var _concatWithSections = function (chunk1, chunk2) {
    const oftenSectionHeader = { header: i18n.t('Common.often') };
    const otherSectionHeader = { header: i18n.t('Common.other') };
    return [oftenSectionHeader]
      .concat(chunk1)
      .concat(otherSectionHeader)
      .concat(chunk2);
  }

  return {
    getSortedItems: getSortedItems,
  }
})();
